<template>
  <div class="home" data-scroll-section>
    <banner :bannerStatus="bannerStatus" />
    <broadcast :scroll="scroll"/>
    <papers style="display: none;" />
    <forum :scroll="scroll" />
    <activety :scroll="scroll" />
    <review :scroll="scroll" ref="reviewP" />
    <support :scroll="scroll" />
  </div>
</template>

<script>

import banner from '@/components/home/Banner'
import broadcast from '@/components/home/Broadcast'
import papers from '@/components/home/Papers'
import forum from '@/components/home/Forum'
import activety from '@/components/home/Activety'
import review from '@/components/home/Review'
import support from '@/components/home/Support'
export default {
  name: 'HomeView',
  components: {
    banner,
    broadcast,
    papers,
    forum,
    activety,
    review,
    support
  },
  props: {
    bannerStatus: Boolean,
    scroll: Object
  }
}
</script>
